export default "__VITE_ASSET__D6oOj7o9__"